import React from "react";
import "./Help.css";

const Help = () => {
  return (
    <div className="help-container">
      <h1>Help</h1>
      <p>Need assistance? Contact our support team or browse our FAQs to find quick answers to common questions.</p>
    </div>
  );
};

export default Help;
